import React from "react";
import Input from "./input";

export default props => (
  <div className="input-group m-b">
    <div className="input-group-prepend">
      <span className="input-group-addon">@</span>
    </div>
    <Input />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/theme/form/input/input-group.jsx